// extracted by mini-css-extract-plugin
export default {"Text":"validation-module__Text--XDcv6","Box":"validation-module__Box--mdSRH"};